import { Stack } from '@fluentui/react';
import { ProgressBar, Text } from '@fluentui/react-components';
import { makeStyles } from '@fluentui/react-components';
import { FC, ReactNode } from 'react';

const useStyles = makeStyles({
	progressBar: {
		width: '200px',
	},
});

const ProgressScreen: FC<{ icon: ReactNode; message: string }> = ({ icon, message }) => {
	const styles = useStyles();
	return (
		<Stack className={'stackPanel'} tokens={{ childrenGap: 10 }}>
			<Stack.Item>{icon}</Stack.Item>
			<Stack.Item>
				<Text size={400} weight={'medium'}>
					{message}
				</Text>
			</Stack.Item>
			<Stack.Item>
				<ProgressBar className={styles.progressBar} />
			</Stack.Item>
		</Stack>
	);
};

export default ProgressScreen;
